import { App, type ModalFuncProps } from 'antd';
import { useMemo } from 'react';
import { wrapDraggableModalNode } from './draggable-modal';

function withDraggableRender(config: ModalFuncProps): ModalFuncProps {
  const { modalRender, title } = config;
  return {
    ...config,
    modalRender: (node) =>
      wrapDraggableModalNode(modalRender ? modalRender(node) : node, {
        draggable: title !== null && title !== undefined,
      }),
  };
}

/**
 * 获取消费 AntD App 上下文的命令式 Modal，并统一为五类提示注入标题栏拖动包装。
 * 每次调用都创建独立拖动实例，不共享弹窗位移。
 */
export function useDraggableModal() {
  const { modal } = App.useApp();

  return useMemo(
    () => ({
      confirm: (config: ModalFuncProps) => modal.confirm(withDraggableRender(config)),
      warning: (config: ModalFuncProps) => modal.warning(withDraggableRender(config)),
      info: (config: ModalFuncProps) => modal.info(withDraggableRender(config)),
      error: (config: ModalFuncProps) => modal.error(withDraggableRender(config)),
      success: (config: ModalFuncProps) => modal.success(withDraggableRender(config)),
    }),
    [modal],
  );
}
